<!---Global-loader-->
<div *ngIf="isSpinner" style="height: 100vh" id="glb-loader" class="loaderShow">
  <img
    src="./assets/images/media/loader.svg"
    class="loader-img"
    alt="loader"
  />
</div>
<!--- End Global-loader-->
<router-outlet></router-outlet>

<app-tap-to-top></app-tap-to-top>
